<template>
  <div
    class="w-full lg:w-[32%] bg-[#1c4848] relative flex flex-col p-8 text-white shrink-0 overflow-hidden group"
    :class="wrapperClass"
  >
    <div
      v-if="backgroundImageUrl"
      class="absolute top-0 left-0 w-full h-full opacity-20 bg-cover bg-center mix-blend-overlay"
      :style="{ backgroundImage: `url(${backgroundImageUrl})` }"
    ></div>
    <div class="absolute -bottom-20 -right-20 w-64 h-64 rounded-full blur-[80px]" :class="glowClass"></div>

    <header class="relative z-10 mb-10">
      <CircleIconInfoTitle
        :text="headerTitle"
        :icon-class="headerIconClass"
        :icon-color-class="headerIconColorClass"
        :text-color-class="headerTextColorClass"
        :circle-bg-class="headerCircleBgClass"
        :circle-border-class="headerCircleBorderClass"
      />
    </header>

    <div class="relative z-10 flex-1 flex flex-col items-center justify-center">
      <BookCoverCard
        :image-url="coverImageUrl"
        :alt="coverAlt"
        :rating="rating"
        :placeholder-icon-class="coverPlaceholderIconClass"
        :rating-icon-class="ratingIconClass"
        :wrapper-class="coverWrapperClass"
      />
      <BookContextInfo
        :badge-text="contextBadgeText"
        :title="contextTitle"
        :subtitle="contextSubtitle"
        :badge-icon-class="contextBadgeIconClass"
        :wrapper-class="contextWrapperClass"
      />
      <QuickStatsGrid
        :items="statsItems"
        :icon-color-class="statsIconColorClass"
        :wrapper-class="statsWrapperClass"
      />
    </div>

    <footer class="relative z-10">
      <SidebarFooterMeta
        :label="footerLabel"
        :value="footerValue"
        :icon-class="footerIconClass"
        :text-color-class="footerTextColorClass"
      />
    </footer>
  </div>
</template>

<script setup>
import CircleIconInfoTitle from './CircleIconInfoTitle.vue';
import BookCoverCard from './BookCoverCard.vue';
import BookContextInfo from './BookContextInfo.vue';
import QuickStatsGrid from './QuickStatsGrid.vue';
import SidebarFooterMeta from './SidebarFooterMeta.vue';

defineProps({
  backgroundImageUrl: {
    type: String,
    default: 'https://fra1.digitaloceanspaces.com/aplusspace/69/12c93ede1d5bbc246b9022e680238d18c1d0c2ec.png'
  },
  glowClass: { type: String, default: 'bg-[#ecd79f]/20' },
  wrapperClass: { type: String, default: '' },
  headerTitle: { type: String, default: 'Library Admin' },
  headerIconClass: { type: String, default: 'pr pr-category' },
  headerIconColorClass: { type: String, default: 'text-[#ecd79f]' },
  headerTextColorClass: { type: String, default: '' },
  headerCircleBgClass: { type: String, default: 'bg-white/10' },
  headerCircleBorderClass: { type: String, default: 'border border-white/10' },
  coverImageUrl: { type: String, default: '' },
  coverAlt: { type: String, default: 'Cover' },
  rating: { type: [String, Number], default: null },
  coverPlaceholderIconClass: { type: String, default: 'pr pr-gallery' },
  ratingIconClass: { type: String, default: 'pr pr-star' },
  coverWrapperClass: { type: String, default: '' },
  contextBadgeText: { type: String, default: '' },
  contextTitle: { type: String, default: '' },
  contextSubtitle: { type: String, default: '' },
  contextBadgeIconClass: { type: String, default: 'pr pr-tick-square' },
  contextWrapperClass: { type: String, default: '' },
  statsItems: {
    type: Array,
    default: () => []
  },
  statsIconColorClass: { type: String, default: 'text-white/40' },
  statsWrapperClass: { type: String, default: '' },
  footerLabel: { type: String, default: 'Last Updated' },
  footerValue: { type: String, default: '' },
  footerIconClass: { type: String, default: 'pr pr-import-564564' },
  footerTextColorClass: { type: String, default: 'text-white/30' }
});
</script>
